import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import Bundle from '@saucelabs/sl-component-bundle';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

import GroupsEnabledContainer from './containers/GroupsEnabledContainer';
import XTMAdminContainer from './containers/XTMAdminContainer';


const importTMContainer = () => import(/* webpackChunkName: "tm-container" */ './containers/TeamManagementContainer');
const importGroupDetails = () => import(/* webpackChunkName: "tm-group-details" */ './ducks/group-details/containers/GroupDetailsContainer');
const importTeamDetails = () => import(/* webpackChunkName: "tm-team-details" */ './team-details/containers/TeamDetailsContainer');
const importUserDetails = () => import(/* webpackChunkName: "tm-user-details" */ './user-details/containers/UserDetailsContainer');
const importSettings = () => import(/* webpackChunkName: "tm-settings" */ './containers/SettingsContainer');


const TeamManagementRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <Redirect
        from={`${match.url}/team/:teamId`}
        to={`${match.url}/teams/:teamId`}
      />
      <XTMAdminContainer>
        {/* xTM Team Admin */}
        <Switch>
          <BundleRoute
            load={importTeamDetails}
            path={`${match.url}/teams/:teamId`}
          />
          <BundleRoute
            load={importUserDetails}
            path={`${match.url}/users/:id`}
          />
        </Switch>
        {/* xTM Org Admin */}
        <Switch>
          <BundleRoute
            load={importSettings}
            path={`${match.url}/settings/:tabName?`}
          />
          <BundleRoute
            load={importTeamDetails}
            path={`${match.url}/teams/:teamId`}
          />
          <Route
            path={`${match.url}/groups/:groupId`}
            render={(props) => (
              <GroupsEnabledContainer>
                <Bundle load={importGroupDetails}>
                  {(Component) => <Component {...props} />}
                </Bundle>
              </GroupsEnabledContainer>
            )}
          />
          <BundleRoute
            load={importUserDetails}
            path={`${match.url}/users/:id`}
          />
          <BundleRoute
            load={importTMContainer}
            path={`${match.url}/:tabName?`}
          />
        </Switch>
      </XTMAdminContainer>
    </Switch>
  </LoginRequiredContainer>
);

TeamManagementRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};


export default TeamManagementRoutes;
